import { useConsole } from "contexts/Console"
import { ImageCLDOneSrc as Image } from "components/media/ImageCLD"
import styled from "@emotion/styled"
import { bold, body50 } from "css/text"

const Root = styled.figure`
  display: flex;
  flex-direction: column;
  gap: 1ex;
  margin-block-start: 10ex;
  place-items: center;

  .logos {
    align-items: center;
    display: flex;
    justify-content: center;
    margin-block-end: 1.875rem;
    width: 100%;
    max-width: 400px;
    height: 110px;

    &:has(> .logo:only-child) {
      max-width: 280px;
    }
  }

  .logo {
    align-items: center;
    align-self: stretch;
    box-sizing: border-box;
    display: flex;
    flex: 0 0 50%;
    min-width: 0;
    height: 100%;
    position: relative;

    & picture {
      width: 100%;
      height: 100%;
    }

    & img {
      display: block;
      height: 100%;
      max-height: none;
      max-width: 100%;
      width: 100%;
      margin: 0;
      object-fit: contain;
    }

    &:only-child {
      flex-basis: 100%;

      & img {
        object-position: center bottom;
      }
    }

    &:not(:only-child) {
      padding-inline: 1.875rem;
    }

    & + .logo::before {
      content: "";
      position: absolute;
      inset-block: 0;
      inset-inline-start: 0;
      border-inline-start: 1px solid rgb(var(--grey));
    }
  }

  figcaption {
    ${body50}
    ${bold}
    text-align: center;
    text-wrap: pretty;
    text-wrap: balance;
    -webkit-text-fill-color: currentColor;
  }
`

export default function Logos({ images, caption }) {
  const console = useConsole()

  console.log("Logos(%o)", { images, caption })
  return (
    <>
      {images.length ? (
        <Root className='logos-block'>
          <div className='logos'>
            {images.map((logo, index) => (
              <div className='logo' key={index}>
                <Image {...logo} sizes='6.375rem' />
              </div>
            ))}
          </div>
          {caption && <figcaption>{caption}</figcaption>}
        </Root>
      ) : null}
    </>
  )
}
